import { useState, useEffect, useRef, useMemo } from 'react';
import './style.css';

const Timer = ({ onExpiring, initialMinute = '0', initialSeconds = '0' }) => {
	const [minutes, setMinutes] = useState(initialMinute);
	const [seconds, setSeconds] = useState(initialSeconds);

	const intervalRef = useRef();

	const expiring = useMemo(() => {
		return minutes <= 5;
	}, [minutes]);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setSeconds(seconds => (seconds > 0 ? seconds - 1 : 59));
			setMinutes(minutes => (minutes > 0 && seconds === 0 ? minutes - 1 : minutes));
		}, 1000);
		return () => clearInterval(intervalRef.current);
	}, [minutes, seconds]);

	useEffect(() => {
		setMinutes(initialMinute);
		setSeconds(initialSeconds);
	}, [initialMinute, initialSeconds]);

	useEffect(() => {
		if (minutes === 0 && seconds === 0) {
			clearInterval(intervalRef.current);
			typeof onExpiring === 'function' && onExpiring();
		}
	}, [minutes, seconds]);

	return (
		<div className={`Timer ${expiring ? 'Expiring' : ''}`}>
			{Math.floor(minutes / 60) > 0 ? `${Math.floor(minutes / 60)}:` : ''}
			{minutes % 60 < 10 && Math.floor(minutes / 60) > 0 ? `0${minutes % 60}` : minutes % 60}:{seconds < 10 ? `0${seconds}` : seconds}
		</div>
	);
};

export default Timer;
